(function () {
  'use strict';

  class Sharer {
    constructor(el) {
      this.DOM = {};
      this.DOM.el = el;
      this.DOM.input = this.DOM.el.querySelector('.js-share-url-input');
      this.DOM.message = this.DOM.el.querySelector('.js-share-url-message');

      this.onClick = () => {
        if (navigator.share) {
          navigator.share({ url: this.DOM.input.value, title: document.title });
        } else {
          if (!this.DOM.message.classList.contains('is-reveal')) {
            navigator.clipboard.writeText(this.DOM.input.value).then(() => {
              this.DOM.message.classList.add('is-reveal');
              setTimeout(() => {
                this.DOM.message.classList.remove('is-reveal');
              }, 2000);
            });
          }
        }
      };

      this.init();
    }

    destroy() {
      if (this.DOM) {
        this.DOM.el.removeEventListener('click', this.onClick);
      }
    }

    init() {
      this.DOM.el.addEventListener('click', this.onClick);
    }
  }

  window.Universe.Sharer = Sharer;
})();
